import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconApp(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M4 3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4Zm1 6V5h4v4H5Zm-1 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H4Zm1 6v-4h4v4H5Zm8-15a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V4Zm2 1v4h4V5h-4Zm-1 8a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-6Zm1 6v-4h4v4h-4Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
